import { useSyncExternalStore } from 'react';
import { getApiActivitySnapshot, subscribeApiActivity } from '../lib/api';

export function CrudActivityIndicator(): React.JSX.Element | null {
  const activity = useSyncExternalStore(
    subscribeApiActivity,
    getApiActivitySnapshot,
    getApiActivitySnapshot,
  );

  if (activity.blocking > 0) {
    return (
      <div className="crud-blocking-layer" role="status" aria-live="polite" aria-busy="true">
        <div className="crud-blocking-card">
          <span className="crud-spinner" aria-hidden="true" />
          <span>Finishing operation…</span>
        </div>
      </div>
    );
  }

  if (activity.background > 0) {
    return (
      <div className="crud-background-status" role="status" aria-live="polite">
        <span className="crud-spinner small" aria-hidden="true" />
        <span>Saving…</span>
      </div>
    );
  }

  return null;
}
